import PropTypes from 'prop-types';
import {Fragment, useState} from 'react';

import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import ListIcon from '@mui/icons-material/MoreVert';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import config from '../../config/config';

const ListSessionTypesItem = props => (
    <Stack
        direction='row'
        spacing={1}
        style={{color: 'rgba(0,0,0,0.55)'}}
        alignItems='center'
        paddingBottom={0.5}
    >
        {props.Icon ? <props.Icon sx={{ fontSize: '1.375rem'}}/> : null}
        {
            props.text
                ? <Typography variant='normal600'>
                    {props.text}
                </Typography>
                : <>{props.children}</>
        }
    </Stack>
);

const ListSessionTypesMenu = props => {
    const [anchorEl, setAnchorEl] = useState(null);
    const menuIsOpen = !!anchorEl;
    return (
        <>
            <Button
                id='positioned-button'
                aria-haspopup='true'
                aria-controls={menuIsOpen ? 'positioned-menu' : undefined}
                aria-expanded={menuIsOpen ? 'true' : undefined}
                onClick={e => setAnchorEl(e.currentTarget)}
            >
                <ListIcon/>
            </Button>
            <Menu
                id='positioned-menu'
                aria-labelledby='positioned-button'
                anchorEl={anchorEl}
                open={menuIsOpen}
                onClose={() => setAnchorEl(null)}
                disableScrollLock={true}
            >
                {(props.menuItems || []).map((m, i) =>
                    <Box key={'menuItem-' + i}>
                        <MenuItem
                            onClick={m.onClick}
                            style={{minWidth: '150px'}}
                        >
                            {
                                m.Icon
                                    ? <m.Icon
                                        style={{marginRight: '0.25em', fontSize: '1rem'}}
                                    />
                                    : null
                            }
                            {m.children}
                        </MenuItem>
                    </Box>
                )}
            </Menu>
        </>
    );
};

const ListSessionTypesCard = props => {
    return (
        <Box
            bgcolor={config().colors.white}
            borderRadius={config().styles.defaultRadius}
            boxShadow={config().styles.defaultBoxShadow}
            border={config().styles.defaultBorder}
            sx={{
                '&:hover': {
                    opacity: 0.8,
                },
            }}
        >
            <Box padding="0.75em">
                <Stack direction='row' justifyContent='space-between'>
                    <Stack justifyContent='center'>
                        <Typography
                            variant='h3'
                            style={{textOverflow: 'ellipsis'}}
                        >
                            {props.title}
                        </Typography>
                    </Stack>
                    <ListSessionTypesMenu menuItems={props.menuItems}/>
                </Stack>
                <Stack spacing={1}>
                    <Stack spacing={1}>
                        {props.listItems && props.listItems.length > 0 ? (
                            <ListSessionTypesItem key={'SessionTypeListItem-0'} {...props.listItems[0]} />
                        ) : null}
                    </Stack>
                    <Stack spacing={1} direction='row' justifyContent='space-between'>
                        <Stack spacing={1}>
                            {(props.listItems || []).slice(1).map((li, i) =>
                                <ListSessionTypesItem key={'SessionTypeListItem-' + i} {...li} />
                            )}
                        </Stack>
                        <Stack direction='row' useFlexGap justifyContent={"flex-end"} flexWrap='wrap'
                               alignItems={"center"} spacing={2} padding={0} margin={0}>
                            <Box>
                                <Button
                                    size='small'
                                    variant='outlined'
                                    color='primary'
                                    onClick={e => {
                                        e.stopPropagation();
                                        props?.buttons?.[0]?.onClick();
                                    }}
                                    disabled={props.buttons[0].disabled}
                                >
                                    {props.buttons[0].children}
                                </Button>
                            </Box>
                            <Box>
                                <Button
                                    size='small'
                                    variant='outlined'
                                    color='primary'
                                    onClick={e => {
                                        e.stopPropagation();
                                        props?.buttons?.[1]?.onClick();
                                    }}
                                    disabled={!!props.buttons[1].disabled}
                                >
                                    {props.buttons[1].children}
                                </Button>
                            </Box>
                        </Stack>
                    </Stack>
                </Stack>
            </Box>
        </Box>
    );
};

ListSessionTypesCard.defaultProps = {
    color: 'rgba(0,0,0,0.2)',
};

ListSessionTypesCard.propTypes = {
    title: PropTypes.string,
    color: PropTypes.string,
    onClick: PropTypes.func,
};

export default ListSessionTypesCard;